"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _moment = _interopRequireDefault(require("moment"));

require("moment/locale/es");

require("moment/locale/fr");

require("@formatjs/intl-pluralrules/polyfill");

require("@formatjs/intl-pluralrules/dist/locale-data/en");

require("@formatjs/intl-pluralrules/dist/locale-data/fr");

require("@formatjs/intl-pluralrules/dist/locale-data/es");

require("@formatjs/intl-relativetimeformat/polyfill");

require("@formatjs/intl-relativetimeformat/dist/locale-data/en");

require("@formatjs/intl-relativetimeformat/dist/locale-data/fr");

require("@formatjs/intl-relativetimeformat/dist/locale-data/es");

var _data = _interopRequireDefault(require("../../_locales/data.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const I18nWrap = ({
  children,
  locale
}) => {
  // Try locale without region code, fallback to 'en'
  const messages = _data.default[locale] || _data.default.en; // Modify Spanish locale with 12h time

  _moment.default.updateLocale('es', {
    longDateFormat: {
      LT: 'h:mm A',
      LTS: 'h:mm:ss A',
      L: 'MM/DD/YYYY',
      LL: 'MMMM [de] D [de] YYYY',
      LLL: 'MMMM [de] D [de] YYYY h:mm A',
      LLLL: 'dddd, MMMM [de] D [de] YYYY h:mm A'
    }
  }); // Globally set locale in moment.js
  // Set again when user changes language in dropdown


  _moment.default.locale(locale);

  const render = () => /*#__PURE__*/_react.default.createElement(_reactIntl.IntlProvider, {
    locale: locale,
    messages: messages
  }, children); // Check if browser supports native intl api


  if (!global.Intl) {
    // Add intl polyfill for browsers that don't support
    require("intl"); // eslint-disable-line


    require("intl/locale-data/jsonp/en.js"); // eslint-disable-line


    require("intl/locale-data/jsonp/es.js"); // eslint-disable-line


    require("intl/locale-data/jsonp/fr.js"); // eslint-disable-line


    return render();
  }

  return render();
};

I18nWrap.propTypes = {
  children: _propTypes.default.element.isRequired,
  locale: _propTypes.default.string.isRequired
};
var _default = I18nWrap;
exports.default = _default;